import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import "./ui.css";

// A thin progress bar across the very top of the viewport that fills
// briefly on every route change (the YouTube/Zoho pattern) -- there is no
// real async load to track here since route data is already fetched by
// each page's own effects, so this simulates progress purely to signal
// "navigation happened" without a blocking spinner.
export default function TopLoadingBar() {
  const { pathname } = useLocation();
  const [active, setActive] = useState(false);
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return undefined;
    }
    setActive(true);
    const done = setTimeout(() => setActive(false), 420);
    return () => clearTimeout(done);
  }, [pathname]);

  return (
    <AnimatePresence>
      {active && (
        <motion.div
          className="ui-top-loading-bar"
          initial={{ scaleX: 0, opacity: 1 }}
          animate={{ scaleX: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
        />
      )}
    </AnimatePresence>
  );
}
